
import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'

import { projectContext, loadingContext, urlValue, unfolder, closeModalVw, openModalVw, useTranslate } from '../../lib'
// import AsideBar from './AsideBar'

import './chat-resume.scss'

import CallChatResume from './CallChatResume'
import CallReportResume from './CallReportResume'
import CallStyles from './CallStyles'
import CallKPI from './CallKPI'
import LoadingReport from './LoadingReport'
import ProjectDashboard from './ProjectDashboard'
import GrammarSpelling from './GrammarSpelling'
import Feedback from './Feedback';
import { InputNesting } from '../../components/common/Inputs/Input'

export default function ReportCall(props) {
    const { data, onClose, onUpdate } = props
    const [loading, setLoading] = useState(false)
    const [call, setCall] = useState(false)
    const [assement, setAssement] = useState(null)
    const [reportType, setReportType] = useState('summary')
    const [listproofread, setListProofRead] = useState([])
    const [styleEvaluations, setStyleEvaluations] = useState([]);
    const [kpiEvaluations, setKpiEvaluations] = useState([]);
    const [url_audio, setUrl_audio] = useState('')
    const [feedbackList, setFeedbackList] = useState([]);
    const [loadingFeedback, setLoadingFeedback] = useState(false);

    const isDashboard = call?.project_name === "General Dashboard";
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    const parseTimeToSeconds = (timeStr) => {
        if (!timeStr) return 0;
        const parts = timeStr.split(':').map(Number);
        if (parts.length === 3) {
            return parts[0] * 3600 + parts[1] * 60 + parts[2];
        } else if (parts.length === 2) {
            return parts[0] * 60 + parts[1];
        }
        return 0;
    }

    const seekToTime = (timeStr) => {
        const audioElement = document.querySelector('#audioID');
        if (audioElement) {
            const seconds = parseTimeToSeconds(timeStr);
            audioElement.currentTime = seconds;
            audioElement.play();
        }
    }
    
    const { t } = useTranslate();
    useEffect(() => {
        setCall(data)
    }, [data])
    useEffect(() => {
        if (data) {
            if (data?.url_audio) {
                getCallUrl()
            }
        }
    }, [data])

    useEffect(()=>{
        console.log('assement==============', assement)
    }, [])

    const closeReport = () => {
        onClose()
    }

    const getCallUrl = async () => {
        let config = {
            headers: {
                apikey: 'validApikey'
            },
        };

        let body = {
            "key_file": data?.audio_name
        }

        let url = `${urlValue}/assesment/audiocall`;

        const res = await axios.post(url, body, config)
        if (res.status === 200) {
            setUrl_audio(res.data);
            document.querySelector('#audioID').src = res.data;
        }
        else {
            setUrl_audio('')
        }
    }

    const getReportsCall = async () => {

        let config = {
            headers: {
                apikey: 'validApikey',
                locale: 'en-US',
                project: 'AI Nesting',
                channel: 'ivr',
                'bussiness-key': call.bussiness_key
            },
        };

        if (!call.session_code) return

        let url = `${urlValue}/assesment/call`;
        const res = await axios.post(url, {
            "sessionCode": call.session_code,
            "project_name": call.project_name,
            "time_seconds": call.time_call_seconds,
            "time_hold": 0,
            "second_hold": 0,
            "hangcall": 0,
            "channel": call.channel,
            "percentage_affectation": call.percentage_affectation,
            "end_time": false,
        }, config)

        if (res.status === 200) {
            console.log('res.data', res.data)
            res.data.time_call = res.data.time_call ? res.data.time_call : call.time_call
            setAssement(res.data)
            setListProofRead(res.data?.listproofread)
            setStyleEvaluations(res.data?.style)
            setKpiEvaluations(res.data?.kpi)

            if (call.evaluations == null) {
                onUpdate(res.data)
            }

        }

    }

    const sendEmail = async () => {
        let config = {
            headers: {},
        };

        const email = document.getElementById('send-email').value || ''

        if (email == '') {
            alert(t('alerts.notSendEmail'))
        }
        else {
            let url = `${urlValue}/send-mail`;
            const res = await axios.post(url, {
                "email": email,
                "record_url": url_audio,
                "sessionCode": call.session_code,
                "messages": assement?.sentiment
            }, config)
            console.log(res.data.data)
            if (res.status === 200 && res.data?.data === true) {
                alert(t('alerts.sendEmail'))
            }
            else {
                alert('Not Send email')
            }
        }

    }

    const isEmptyOrNull = (obj) => {
        return !obj || (typeof obj === 'object' && Object.keys(obj).length === 0);
    };
    useEffect(() => {
        if (call) {
            if (call.project_name === "General Dashboard") {
                setReportType('project-dashboard');
                const mockAssessment = {
                    time_call: "00:00:00",
                    sentiment: [],
                };
                setAssement(mockAssessment);
            } else {
                // CAMBIO: Resetear a summary para llamadas normales
                setReportType('summary');
                getReportsCall();
            }
        }
    }, [call]);

    const openTap = (type, e) => {
        if (isDashboard && type !== 'project-dashboard') {
            return;
        }
        document.querySelectorAll('.btn-tap-report').forEach(item => {
            item.classList.remove('active')
        });
        e.currentTarget.classList.add('active')
        setReportType(type)

        if (type === 'feedback' && feedbackList.length === 0) {
            getProjectFeedback();
        }
    }

    const getProjectFeedback = async () => {
        if (!call?.project) return;

        try {
            setLoadingFeedback(true);
            let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token

            let config = {
                headers: {
                    apikey: 'validApikey',
                    locale: 'en-US',
                    project: 'AI Nesting',
                    channel: 'ivr',
                    'bussiness-key': call.bussiness_key,
                    'access-token': token,
                },
            };

            const res = await axios.get(
                `${urlValue}/studio/project/${call.project}/feedback/calls`,
                config,
            );

            if (res.status === 200 && res.data?.data) {
                setFeedbackList(res.data.data);
            } else {
                setFeedbackList([]);
            }
        } catch (error) {
            console.error('[Feedback][Project]', error);
            setFeedbackList([]);
        } finally {
            setLoadingFeedback(false);
        }
    };


    return (
        <div className='cont-reports  '  >
            <div className='content-btn-tap-rp  '>
                <div className='btn-tap-report ' onClick={(e) => { openTap('call', e) }}>
                    {t('reports.callReport')}
                </div>
                <div className='btn-tap-report active' onClick={(e) => { openTap('summary', e) }} >
                    {t('reports.callSummary')}
                </div>

                {call.channel === 'voice' && styleEvaluations && !isEmptyOrNull(styleEvaluations) && (
                <div className='btn-tap-report' onClick={(e) => { openTap('styles', e) }}>
                    {t('reports.styleTitle')}
                </div>
                )}
                
                {listproofread.length > 0 && (
                    <div className='btn-tap-report' onClick={(e) => { openTap('grammar', e) }}>
                        {t('reports.grammarSpelling')}
                    </div>
                )}

                {kpiEvaluations && !isEmptyOrNull(kpiEvaluations) && (
                    <div className='btn-tap-report' onClick={(e) => { openTap('sections', e) }}>
                        {call.channel === 'chat' ? t('reports.chatBehavior') : t('reports.callBehavior')}
                    </div> 
                )}

                <div className='btn-tap-report' onClick={(e) => { openTap('feedback', e) }}>
                    {t('reports.feedback')}
                </div>

                <div className='flex-1'></div>
                <div className='btn-tap-report mr-0' style={{ marginRight: 0 }} onClick={(e) => { openTap('project-dashboard', e) }} >
                    {t('reports.projectDashboard')}
                </div>
            </div>
            
            <div className="bg-white w-full pr-[1rem]">
                <div className="bg-white w-full overflow-auto">

                    {reportType === 'summary' &&
                        (assement !== null ? <CallChatResume data={assement} callinfo={call} /> : <div style={{ backgroundColor: "white", width: '100%', height: '50vh', justifyContent: 'center', display: 'flex', alignItems: 'center' }}><LoadingReport /></div>)
                    }
                    {reportType === 'call' &&
                        (assement !== null ? <CallReportResume data={assement} onSeekToTime={seekToTime} sessionCode={call.session_code} onQualificationUpdate={(updatedEvals) => { setAssement(prev => ({ ...prev, ...updatedEvals })) }} /> : <div style={{ backgroundColor: "white", width: '100%', height: '50vh', justifyContent: 'center', display: 'flex', alignItems: 'center' }}><LoadingReport /></div>)
                    }
                    {reportType === 'styles' &&
                        (assement !== null ? <CallStyles data={assement} /> : <div style={{ backgroundColor: "white", width: '100%', height: '50vh', justifyContent: 'center', display: 'flex', alignItems: 'center' }}><LoadingReport /></div>)
                    }
                    {reportType === 'grammar' && 
                        (assement !== null ? <GrammarSpelling data={assement} /> :  <div style={{ backgroundColor: "white", width: '100%', height: '50vh', justifyContent: 'center', display: 'flex', alignItems: 'center' }}><LoadingReport /></div>)
                    }
                    {reportType === 'sections' &&
                        (assement !== null ? <CallKPI data={assement} onSeekToTime={seekToTime} /> : <div style={{ backgroundColor: "white", width: '100%', height: '50vh', justifyContent: 'center', display: 'flex', alignItems: 'center' }}><LoadingReport /></div>)
                    }
                    {reportType === 'feedback' && (
                        loadingFeedback ? (
                            <div className='loading-container'>
                                <LoadingReport />
                            </div>
                        ) : (
                            <Feedback data={feedbackList} />
                        )
                    )}

                    {reportType === 'project-dashboard' &&
                        (assement !== null ? (
                            <ProjectDashboard 
                                data={{
                                    id: id,
                                    id_proyect: call.project_name === "General Dashboard" ? id : call.project, 
                                    isGeneralDashboard: call.project_name === "General Dashboard",
                                    userId: id
                                }} 
                            />
                        ) : (
                            <div style={{ backgroundColor: "white", width: '100%', height: '50vh', justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
                                <LoadingReport />
                            </div>
                        ))
                    }
                    <div className='w-full flex items-center justify-center sticky-audio' style={{ backgroundColor: 'white' }}>
                        <div className='flex items-center' >
                            <div style={{ color: '#0b5fa3', width: 130 }}>
                                <span>{t('call.playConversation')}</span>
                            </div>
                            <audio id="audioID" controls >
                                <source type="audio/ogg" />
                            </audio>
                        </div>
                        <div className='flex items-center' >
                            <input
                                id="send-email"
                                className='input-data'
                                style={{ marginRight: '5px' }}
                                type="text"
                            />
                            <buton className='button-setup setup-btn' onClick={sendEmail}>{t('call.sendToEmail')}</buton>
                        </div>
                        <div className="btn-close-report  " onClick={closeReport}>
                            {t('common.close')}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
